module.exports = {
  // 模块名称
  elePatroReport: {
      // 按钮类
      button: {
        export: 'Export',
        reset: 'Reset',
        query: 'Query',
      },
      // 文字标签类
      label: {
          account: 'Account',
          name: 'Name',
          passWd: 'Password',
          phone: 'Phone',
          email: 'Email',
          status: 'Status',
          createTime: 'Creation time',
          enable: 'Enable',
          disabled: 'Disable',
          lock: 'Lock',
          remark: 'Remark',
          selAccount: 'Selectable account groups',
          seletedAccount: 'Selected account groups',
          operation: 'Operations',
          duration: 'License validity period',
          newPW: 'New password',
          confirmPW: 'Confirm password'
      },
      // 提示类
      placeholder: {
          password: 'Enter password',
          name: 'Enter name',
          remark: 'Enter remark',
          status: 'Select status',
          account: 'Enter account',
          newPW: 'Enter new password',
          confirmPW: 'Enter confirm password',
          startDate: 'Start date',
          endDate: 'End date',
          email: 'Enter email',
          phone: 'Enter phone'
      },
      // 消息类
      message: {
          resetPW: 'Password cannot match account name,please reset',
          resetSuccess: 'Reset successful',
          nodata: 'No data',
          phone: 'Enter cellphone number',
          email: 'Enter email address',
          confirmPW: 'Enter confirm password',
          less20: 'The length is between 6 and 20 characters',
          less30: 'The length is between 4 and 30 characters',
          less50: 'The length is between 1 and 50 characters',
          passWd: 'Enter password',
          name: 'Enter name',
          account: 'Enter account',
          emailCheck: 'Email format is incorrect',
          emailFormat: 'Mailbox prefix is 4 to 18 characters',
          passwordCheck: 'Password format is incorrect',
          passwordCheck2: 'Must contain two or more letters, Numbers, or special characters!',
          phoneCheck: 'Phone number format is incorrect',
          againPW: 'Enter password again',
          newPW: 'Enter new password',
          diffPW: 'Inconsistent input password twice',
          nameFormat: 'Be number,letter,underscore,first is letter,not special character',
          delSuccess: 'Delete Successfully',
          selectDel: 'Please select the account you want to delete',
          confirmDel: 'This will permanently delete the account. Continue?',
          setRelations: 'Set account group successfully',
          addSuccess: 'Add Successfully',
          editSuccess: 'Edit Successfully',
          unlockSuccess: 'Unlock Successfully',
          unlockAccount: 'Are you sure you want to unlock this account?',
          permanentlyDel: 'This will permanently delete the account. Continue?',
          enableAccount: 'Are you sure you want to enable this account?',
          disableAccount: 'Are you sure you want to disable this account?',
          enableSuccess: 'Enabled successfully',
          disableSuccess: 'Disabled successfully',
      },
      // 标题类
      title: {
          relations: 'Account membership setting',
          warn: 'Warning',
          resetPW: 'Reset password',
          addAccount: 'Add account',
          editAccount: 'Edit account',
          viewAccount: 'View account'
      }
  }
}